// extracted by mini-css-extract-plugin
module.exports = {"container":"_80ad21f8ef--container--3rVGU","img":"_80ad21f8ef--img--3O13R","hide-scroll":"_80ad21f8ef--hide-scroll--1vFjC"};